const dischargeTerm = `
<table align="center" cellpadding="0" cellspacing="0" width="600"  style="border-collapse: collapse;">
    <tr>
        <td>
            <img height="70" src="http://fcstoragebr.blob.core.windows.net/images/Fcamara/Logotipo-Horizontal-FCamara-2015.png">
        </td>
    </tr>
    <tr>
        <td align="center" height='100px'>
            <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>CARTA DE QUITAÇÃO DE PRESTAÇÃO DE SERVIÇOS</strong></p>
        </td>
    </tr>
    <tr>
        <td>
            <div class="main">

                <p>
                    Pelo presente instrumento, e na melhor forma de direito, de um lado,
                </p>

                <p>
                    <strong>FCAMARA CONSULTORIA E FORMAÇÃO EM INFORMÁTICA LTDA</strong>, estabelecida à Rua Bela Cintra, 986, 2º andar Consolação – São Paulo/SP – CEP 01415-906, inscrita no CNPJ/MF sob o nº. 03.775.758/0001-90 doravante designado <strong>"CONTRATANTE"</strong>, e de outro.
                </p>

                <p>
                    <strong>{{consultantname}}</strong>, portador do CPF nº {{consultantcpf}}, residente e domiciliado na residente e domiciliado {{consultantaddress}}, nº {{consultantnumber}}, CEP.{{consultantcep}}, {{consultantcity}}/{{consultantstate}}, doravante designada <strong>"CONTRATADO"</strong>.
                </p>

                <p>
                    As partes declaram a quitação dos serviços prestados do período de <strong>{{consultantstart}}</strong> à <strong>{{consultantend}}</strong>, restando {{contractterminationqtdHours}} ({{contractterminationqtdHoursFull}}) horas a serem pagas no valor total de <strong>R$ {{contractterminarionvalue}}</strong> ({{contractterminarionvalueFull}}) reais.
                </p>

                <p>
                    As partes concordam em manter o sigilo e a confidencialidade em relação às informações fornecidas e recebidas, durante a relação de prestação de serviços ocorrida, assim como qualquer material de natureza sigilosa ou de propriedade intelectual protegida que teve acesso, não revelando tal material ou informação a terceiros, pelo prazo de 01 (um) ano após a assinatura do presente instrumento.
                </p>

                <p>
                    Esclarecem as partes que são exclusivamente da CONTRATANTE todos os direitos de propriedade intelectual decorrente dos sistemas de processamento de dados e de software, metodologias e manuais utilizados e desenvolvidos ao longo da prestação de serviços aqui ajustada.
                </p>

                <p>
                    Todos os conflitos, as controvérsias e diferenças decorrentes deste Contrato ou a ele relacionadas,  serão definitivamente resolvidos por meio de arbitragem, assumindo como cláusula compromissória, nos termos da Lei nº 9.307, de 23 de setembro de 1996 (Lei de Arbitragem), alterada pela Lei nº 13.129, de 2015, e subsidiariamente da Lei nº  13.105/2015 (Código de Processo Civil), renunciando a qualquer outro, por mais privilegiado que seja, para dirimir qualquer dúvida que possa surgir deste instrumento.
                </p>

                <p>
                    O CONTRATADO tem o prazo de 05 (cinco) dias a partir da devolução deste para devolução dos equipamentos na sede da CONTRATANTE, no endereço: Rua Bela Cintra, 986, 2º andar – Consolação – São Paulo/SP, CEP 01415-906. Caso os equipamentos não sejam entregues no prazo mencionado, automaticamente presume-se autorização tácita para o desconto dos valores a receber no importe de R$ 3.500,00 (três mil e quinhentos reais).
                </p>

                <p>
                    Sendo assim, nada mais tendo a reclamar em qualquer tempo ou modalidade, seja a qual título for, nem a <strong>CONTRATANTE</strong> nem a <strong>CONTRATADA</strong>, dando-se mutuamente plena, geral, rasa e irrevogável quitação.
                </p>

                <p>
                    E, por estarem assim juntas, certas e contratadas, as partes assinam o presente instrumento em 02 (duas) vias em igual teor e forma na presença das testemunhas abaixo assinadas,
                </p>

                <br>
                </td>
                </tr>
                <tr>
                    <td align="center" height='60px'>

                <p style="text-align: center; margin-top: 50px;">
                    <strong>São Paulo</strong>, {{consultantend}}
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        <strong>FCAMARA CONSULTORIA E FORMACAO EM INFORMATICA LTDA</strong>
                    </span>
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        <strong>{{consultantname}}</strong><br>
                    </span>
                </p>

                <!-- TESTEMUNHASSSS -->
                <p style="margin-top: 50px;">
                    <strong>TESTEMUNHAS</strong>
                </p>
                <div class="testemunhas" style="margin: 0; text-align: left;">
                    <table style="width: 100%;">
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td style="width: 50%;">
                                    <span>
                                        1. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                                <td style="width: 50%;">
                                    <span>
                                        2. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </td>
            </tr>
        </table>
`;

export default dischargeTerm;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentTemplates/dischargeTerm.ts